import { Box, Button } from '@mui/material';

//Sync with \app\Enumerations\MessageTemplatePlaceholderEnum.php
export const ICON_LAST_APPOINTMENT = '📅';
export const ICON_NEXT_DEADLINE_M = '🛠';
export const ICON_NEXT_DEADLINE_PF = '🔥';

function Decorator({ addEmoji, sx, ...props }) {
    const fire = (icon) => () => addEmoji?.(icon);

    return (
        <Box sx={[{ display: 'flex', gap: 0.5, flex: 1 }, sx]} {...props}>
            <Button variant="outlined" size="small" onPointerDown={(e) => { e.preventDefault(); fire(ICON_LAST_APPOINTMENT)(); }}>
                Ultimo appuntamento {ICON_LAST_APPOINTMENT}
            </Button>
            <Button variant="outlined" size="small" onPointerDown={(e) => { e.preventDefault(); fire(ICON_NEXT_DEADLINE_M)(); }}>
                Scadenza manutenzione {ICON_NEXT_DEADLINE_M}
            </Button>
            <Button variant="outlined" size="small" onPointerDown={(e) => { e.preventDefault(); fire(ICON_NEXT_DEADLINE_PF)(); }}>
                Scadenza prova fumi {ICON_NEXT_DEADLINE_PF}
            </Button>
        </Box>
    );
}

export default Decorator;
